import { Environment } from './types/common'
export const environment = (process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? Environment.development) as Environment
export const isLocalDev = !process.env.NODE_ENV || process.env.NODE_ENV === Environment.development
